import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";
import { Button } from "@/components/ui/button";
import { downloadBlob } from "@/lib/download";
import { History, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function PolicyHistory({ sector, title, refreshKey }) {
  const [events, setEvents] = useState(null);
  const [busy, setBusy] = useState(false);
  const [showAll, setShowAll] = useState(false);
  useEffect(() => { api.get(`/me/policies/${sector}/${encodeURIComponent(title)}/history`).then((r) => setEvents(r.data)).catch((e) => logError("policy-history", e)); }, [sector, title, refreshKey]);
  const exportPdf = async () => {
    setBusy(true);
    try { const res = await api.get(`/me/policies/${sector}/${encodeURIComponent(title)}/history/export`, { responseType: "blob" }); downloadBlob(res, "audit-trail.pdf"); }
    catch { toast.error("Export failed"); } finally { setBusy(false); }
  };
  const list = showAll ? events || [] : (events || []).slice(0, 6);
  return (
    <div className="rounded-xl border border-border p-4 space-y-2" data-testid="policy-history">
      <div className="flex items-center justify-between gap-2">
        <p className="font-medium text-sm flex items-center gap-2"><History className="w-4 h-4 text-accent" /> Audit trail</p>
        <Button size="sm" variant="outline" onClick={exportPdf} disabled={busy} data-testid="policy-history-export">{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <><Download className="w-3.5 h-3.5 mr-1" /> PDF for inspectors</>}</Button>
      </div>
      {!events ? <p className="text-xs text-muted-foreground">Loading…</p> : !events.length ? <p className="text-xs text-muted-foreground" data-testid="policy-history-empty">No activity recorded yet — reviews, edits and sign-offs will appear here.</p> : (
        <ol className="text-xs space-y-1.5" data-testid="policy-history-list">
          {list.map((e, i) => (
            <li key={i} className="flex gap-2">
              <span className="text-muted-foreground shrink-0 w-[88px]">{new Date(e.at).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "2-digit" })}</span>
              <span><b>{e.label}</b> · {e.actor}{e.detail && <span className="text-muted-foreground"> — {e.detail}</span>}</span>
            </li>
          ))}
        </ol>
      )}
      {events && events.length > 6 && <button type="button" className="text-xs text-primary hover:underline" onClick={() => setShowAll(!showAll)} data-testid="policy-history-toggle">{showAll ? "Show less" : `Show all ${events.length}`}</button>}
    </div>
  );
}
